var _rect, _rect2, _path, _g, _g2, _path2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 186 125",
    id: "SectionsCtaDark",
    style: {
      width: "100%",
      height: "100%",
      filter: "none",
      opacity: 0.3
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 124.224,
    fill: "none",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    x: 72,
    y: 10,
    fill: "#212121",
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 5.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M100.693 36.983V25.017c0-.94-.77-1.71-1.71-1.71H87.017c-.94 0-1.71.77-1.71 1.71v11.966c0 .94.77 1.71 1.71 1.71h11.966c.94 0 1.71-.77 1.71-1.71Zm-10.685-4.701 2.137 2.573L95.137 31l3.846 5.128H87.017l2.991-3.846Z",
    clipRule: "evenodd",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 6,
    x: 55,
    y: 72,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 6,
    x: 97,
    y: 72,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    x: 119,
    y: 72,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    x: 44.5,
    y: 88,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 4,
    x: 66.5,
    y: 88,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    x: 112.5,
    y: 88,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#717171",
    fillRule: "evenodd",
    d: "M79.65 102a2.895 2.895 0 0 0-2.894 2.895v6.433a2.896 2.896 0 0 0 2.895 2.896h26.698a2.896 2.896 0 0 0 2.895-2.896v-6.433a2.895 2.895 0 0 0-2.895-2.895H79.651Zm9.042 5.468a1 1 0 0 0 0 2h8.937a1 1 0 1 0 0-2h-8.937Z",
    clipRule: "evenodd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 123.224,
    x: 0.5,
    y: 0.5,
    stroke: "#cccccc",
    strokeWidth: 1,
    strokeOpacity: 1,
    rx: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSkeleton);
export default __webpack_public_path__ + "static/media/profile_skeleton.2366c27321b7dcd9242f5e5dcb32be4e.svg";
export { ForwardRef as ReactComponent };